import { createAction } from 'typesafe-actions';

import { Actions as SpecialOffersActions } from './constants';

interface EnterCodeRedemptionFlowParams {
  code: $TSFixMe;
  isOfferPath: $TSFixMe;
}

export const enterCodeRedemptionFlow = createAction(
  SpecialOffersActions.ENTER_CODE_REDEMPTION_FLOW,
  (params: EnterCodeRedemptionFlowParams) => params,
)<EnterCodeRedemptionFlowParams>();
export type EnterCodeRedemptionFlowAction = ReturnType<typeof enterCodeRedemptionFlow>;

interface UpdateRedemptionStateParams {
  specialOfferCode: $TSFixMe | null;
  specialOfferStatus: $TSFixMe | null;
}

// null means don't change data, any other value, falsy or not, will overwrite current value
export const updateSpecialOfferRedemptionState = createAction(
  SpecialOffersActions.UPDATE_REDEMPTION_STATE,
  ({ specialOfferCode = null, specialOfferStatus = null }: UpdateRedemptionStateParams) => ({
    specialOfferCode,
    specialOfferStatus,
  }),
)<UpdateRedemptionStateParams>();
export type UpdateRedemptionStateAction = ReturnType<typeof updateSpecialOfferRedemptionState>;

interface ResetSpecialOfferParams {
  shouldResetCampaignCopy: boolean;
  shouldResetError: boolean;
}

export const resetSpecialOffer = createAction(
  SpecialOffersActions.RESET_SPECIAL_OFFER,
  (
    {
      shouldResetCampaignCopy = true,
      shouldResetError = true,
    }: Partial<ResetSpecialOfferParams> = {
      shouldResetCampaignCopy: true,
      shouldResetError: true,
    },
  ) => ({
    shouldResetCampaignCopy,
    shouldResetError,
  }),
)<ResetSpecialOfferParams>();
export type ResetSpecialOfferAction = ReturnType<typeof resetSpecialOffer>;
